import { render, staticRenderFns } from "./provincecarrierqualitydata.vue?vue&type=template&id=2fbec3aa&scoped=true"
import script from "./provincecarrierqualitydata.vue?vue&type=script&lang=js"
export * from "./provincecarrierqualitydata.vue?vue&type=script&lang=js"
import style0 from "./provincecarrierqualitydata.vue?vue&type=style&index=0&id=2fbec3aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbec3aa",
  null
  
)

export default component.exports